import { render, staticRenderFns } from "./OrderLensModal.vue?vue&type=template&id=5b04ccab"
import script from "./OrderLensModal.vue?vue&type=script&lang=js"
export * from "./OrderLensModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports